import { STORE_ID, TYPES } from "./types";

const INITIAL_STATE = {
  pesquisa: {
    id: "",
    descricao: "",
    data: "",
    nacional: null,
  },
  registros: {
    id: "",
    descricao: "",
    data: "",
    nacional: null,
  },
  item: {
    id: "",
    descricao: "",
    data: "",
    nacional: null,
  },
  nacional: [
    { value: true, label: "Sim" },
    { value: false, label: "Não" },
  ],
  invalid: {
    id: false,
    descricao: false,
    data: false,
    nacional: "",
  },
  allItems: {
    quantidade: "0",
    quantidadeTotal: "0",
    totalPaginas: "0",
  },
  activeTab: "Search",
  copy: {},
  items: [],
  feriados: [],
  totals: {},
  seeRegister: false,
  selectedItems: [],
  permitions: {
    criar: false,
    deletar: false,
  },
};

export default function feriado(state = INITIAL_STATE, action) {
  switch (action.storeId) {
    case STORE_ID:
      switch (action.type) {
        case TYPES.SET_PERMITIONS:
          return { ...state, permitions: action.value };
        case TYPES.SET_ACTIVE_TAB:
          return { ...state, activeTab: action.value };
        case TYPES.SET_SEE:
          return { ...state, seeRegister: action.value };
        case TYPES.FERIADOS:
          return { ...state, feriados: action.value };
        case TYPES.PESQUISA:
          return {
            ...state,
            pesquisa: action.value,
            ...(action.value.id && {
              item: action.value,
              registros: action.value,
            }),
          };
        case TYPES.SET_ITEMS:
          return { ...state, items: action.value };

        case TYPES.SET_ITEM:
          return {
            ...state,
            item: {
              ...state.item,
              ...action.value,
            },
          };

        case TYPES.SET_TOTALS:
          return { ...state, totals: action.value };
        case TYPES.SET_SELECTED_ITEMS:
          return { ...state, selectedItems: action.value };
        case TYPES.GET_ALL_ITENS:
          return { ...state, allItems: action.value };
        case TYPES.CLEAN_INVALID:
          return { ...state, invalid: INITIAL_STATE.invalid };
        case TYPES.FERIADO_COPY:
          return {
            ...state,
            registros: action.value,
          };
        case TYPES.CLEAN_SEARCH:
          return { ...state, pesquisa: INITIAL_STATE.pesquisa };
        case TYPES.CLEAN_REGISTER:
          return {
            ...state,
            item: INITIAL_STATE.item,
            invalid: INITIAL_STATE.invalid,
          };
        default:
          return { ...state };
      }
    default:
      return { ...state };
  }
}
